module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/monogram-bc68924f8defc3c2b9a363ae97884a0c.jpg";